<template>
  <div v-if="props.appendList.length > 0"
       class="append">
    <CaretUpOutlined class="append-icon" />
    <div v-for="comment in props.appendList"
         :key="comment.id"
         class="append-content">
      <div>
        <div class="append-time">{{ append_time(comment.createdAt,
          props.createdAt) }}</div>
        <div class="append-box">{{ comment.content }}</div>
      </div>
      <div v-if="comment.images"
           style="display: flex;align-items: center;">
        <div v-for="(image, index) in comment.images?.split(',')"
             :key="index">
          <a-popover placement="right">
            <template #content>
              <img :src="toUrl(image)"
                   class="comment-popover" />
            </template>
            <img :src="toUrl(image)"
                 class="comment-image" />
          </a-popover>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { toUrl } from "../../../../utils/index"
import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  appendList: any
  createdAt: string
}>()

const append_time = (time1: any, time2: any) => {
  const startDay = dayjs(time1).startOf('day')
  const endDay = dayjs(time2).startOf('day')
  const daysDifference = startDay.diff(endDay, 'day')
  const title = daysDifference == 0 ? `${t('Comment.CommentAppend.sameDay')}` : `${daysDifference
    }${t('Comment.CommentAppend.daysLater')}`
  return `【${title}${t('Comment.CommentAppend.appendReview')}】`
}
</script>
<style scoped lang="less">
.append {
  position: relative;
  margin-top: 16px;
  padding: 10px;
  background-color: #f6f6f6;

  .append-icon {
    font-size: 20px;
    position: absolute;
    top: -14px;
    left: 20px;
    color: #f6f6f6;
  }

  .comment-image {
    width: 50px;
    height: 50px;
    margin-top: 10px;
    cursor: pointer;
  }

  .append-content {
    .append-time {
      color: #DE4A09;
      display: inline-block;
    }

    .append-box {
      display: inline;
      word-break: break-all;
    }
  }
}

.ant-popover {
  width: 260px;

  .comment-popover {
    max-width: 260px;
    // height: 200px;
  }
}
</style>
